import { defineMessages } from 'react-intl'

export default defineMessages({
  deliveries: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.components.OrderDeliveries.deliveries',
    defaultMessage: 'Deliveries',
  },
})
